import { render, staticRenderFns } from "./FieldStandard.vue?vue&type=template&id=141ba891&scoped=true&"
import script from "./FieldStandard.vue?vue&type=script&lang=js&"
export * from "./FieldStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ba891",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141ba891')) {
      api.createRecord('141ba891', component.options)
    } else {
      api.reload('141ba891', component.options)
    }
    module.hot.accept("./FieldStandard.vue?vue&type=template&id=141ba891&scoped=true&", function () {
      api.rerender('141ba891', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldStandard.vue"
export default component.exports